import React, {useEffect, useLayoutEffect, useState} from 'react';
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";

import Highcharts from 'highcharts';
import { enterExitStyle, CSSGrid, layout } from "react-stonecutter";

import ProjectCard from "./ProjectCard";
// import ProjectFilterBtns from "../../../packages/projectcards/ProjectFilterBtns";
import useDataSource from "../../../../hooks/useDataSource";
import useWindowSize from "../../../../hooks/useWindowSize";

import { styled, Grid, LinearProgress } from '@mui/material';

const PREFIX = 'PortfolioStoneCutter';

const classes = {
    root: `${PREFIX}-root`,
    summaryCards: `${PREFIX}-summaryCards`,
    summaryGrid: `${PREFIX}-summaryGrid`,
    projectCards: `${PREFIX}-projectCards`,
    filterRow: `${PREFIX}-filterRow`,
    tableActionButton: `${PREFIX}-tableActionButton`,
    linearProgress: `${PREFIX}-linearProgress`
};

const Root = styled('div')((
    {
        theme
    }
) => ({
    [`&.${classes.root}`]: {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100%',
		backgroundColor: theme.palette.background.default
    },

    [`& .${classes.summaryCards}`]: {
        height: '100%',
        width: '100%',
        minWidth: '315px',
        position: '-webkit-sticky', /* Safari */
        position: 'sticky',
        alignSelf: 'flex-start', // https://stackoverflow.com/questions/44446671/my-position-sticky-element-isnt-sticky-when-using-flexbox
        top: '0px',
        zIndex: '100',
        //marginTop: '-10px',
        marginBottom: '10px'
    },

    [`& .${classes.summaryGrid}`]: {
        height: '100%',
        backgroundColor: theme.palette.primary.background,
    },

    [`& .${classes.projectCards}`]: {
        flex: 'auto',
        height: '100%',
        minWidth: '315px',
        zIndex: '50'
    },

    [`& .${classes.filterRow}`]: {
        height: '100%',
        width: '100%',
        minWidth: '315px',
        backgroundColor: theme.palette.primary.background,
        position: '-webkit-sticky', /* Safari */
        position: 'sticky',
        alignSelf: 'flex-start', // https://stackoverflow.com/questions/44446671/my-position-sticky-element-isnt-sticky-when-using-flexbox
        bottom: '0',
        zIndex: '100'
    },

    [`& .${classes.tableActionButton}`]: {
        position: 'absolute',
        top: '50vh',
        right: '0px',
        width: '50px',
        height: '50px',
        zIndex: '150'
    },

    [`& .${classes.linearProgress}`]: {
        height: '1px'
    }
}));

// import {
//     dataSetPortfolioFilterVals
// } from "../../../redux/data/dataActions";
// import {
//     persistPortfolioDefaultView
// } from "../../../redux/persist/persistActions";


window.Highcharts = Highcharts;
window.Highcharts.setOptions({
    lang: {
        numericSymbols: ["k" , "M" , "B" , "T" , "P" , "E"]
    }
});

export default function StoneCutter({id, configuration}) {
    // const dispatch = useDispatch();
    const { enter, entered, exit } = enterExitStyle.simple;

    // console.log('PortfolioLayout:render()');

    // Get active location of app
    // const location = useLocation();

    // App State
    const app = useSelector(state => state.app);
    // const config = useSelector(state => state.config);
    const data = useSelector(state => state.data);
    // const portfolioDefaultViewTable = useSelector(state => state.persist.portfolioDefaultViewTable);

    // Page Components
    const dataSource = useDataSource(configuration.dataSource.name);    // App State
	const size = useWindowSize();

    // Component State
    const [projects, setProjects] = useState([]);
    const [cardColumns, setCardColumns] = useState(2);

    // Persist the Portfolio top row filter values as the app is filtered
    useEffect( () => {
        // console.log('PortfolioLayout: UseEffect, [dataSource.data]');
        if (dataSource.data && dataSource.fetched && !dataSource.error) {

            const compiledCardArray = [];
            for (let p = 0; p < dataSource.data.length; p++) {
                const project = dataSource.data[p];

                compiledCardArray.push(
                    <div key={project[configuration.dataSource.projectCardKey]} itemHeight={275}>
                        <ProjectCard project={project} element={configuration.element} staged={data.ViewStaged}/>
                    </div>
                );
            }
            setProjects(compiledCardArray);
        } else {
            setProjects([]);
        }
    }, [dataSource.data]);

    useLayoutEffect(() => {
        let columns = 0;
        if (size.width > 0) {
            const canvasWidth = size.width - (app.rightDrawerOpen ? app.rightDrawerWidth : 0);
            columns = canvasWidth / (300 + 20);
            columns = parseInt(columns, 0);
            if (columns < 1) {
                setCardColumns(1);
            } else {
                setCardColumns(columns);
            }
        }
    });

    return (
        <Root className={classes.root}>
            {dataSource.fetching &&
            <LinearProgress className={classes.linearProgress}/>
            }
            {!dataSource.fetching &&
            <div className={classes.linearProgress}></div>
            }

            {/* Project Cards */}
            <div className={classes.projectCards}>
                <Grid container justifyContent={"center"} sx={{bgcolor: 'background.default'}}>
                    <Grid item>
                        <div style={{
                            display: 'inline-block',
                            width: 'calc(100% - 350px)',
                            minWidth: '320px',
                            paddingBottom: '10px'
                        }}>
                            <CSSGrid
                                component="div"
                                columns={cardColumns}
                                columnWidth={300}
                                gutterWidth={10}
                                gutterHeight={10}
                                layout={layout.pinterest}
                                duration={600}
                                itemHeight={275}
                                enter={enter}
                                entered={entered}
                                exit={exit}
                                // enter={() => ({ scale: 1, opacity: 1, rotate:-720 })}
                                // entered={() => ({ scale: 1, opacity: 1, rotate:-720 })}
                                // exit={() => ({ scale: 1, opacity: 1, rotate:-720 })}
                                springConfig={{stiffness: 170, damping: 26}}
                            >
                                {projects}
                            </CSSGrid>
                        </div>
                    </Grid>
                </Grid>
            </div>

        </Root>
    );
}
